import { Block, Link, Typography } from '@aloft/toolkit-sui';

import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';

import { featuresSelectors } from '../../redux/features/selectors/featuresSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';
import { getConfig } from '../../utils/getConfig.ts';
import { getTrialEndMessage } from '../../utils/getTrialEndMessage.ts';
import { AccountModuleDeps } from './types.ts';

const { selectShouldAllowTrialWithoutPayment } = featuresSelectors;

type Props = {
  subscription: AccountModuleDeps['subscription'];
};

export const SubscriptionManagementContent = ({ subscription }: Props) => {
  const customerPortalLink = getConfig('STRIPE_CUSTOMER_PORTAL_LINK') as string;

  return (
    <>
      <TrialInformation subscription={subscription} />
      <Link href={customerPortalLink} isExternal>
        Manage your subscription
      </Link>
    </>
  );
};

const TrialInformation = ({ subscription }: { subscription: Props['subscription'] }) => {
  const allowTrialWithoutPayment = useAppSelector((state) =>
    selectShouldAllowTrialWithoutPayment(state, subscription),
  );

  const isTrialing =
    subscription.hasActiveSubscription === true && subscription.type === 'trialing';
  if (!isTrialing) return null;

  const trialEndMessage = getTrialEndMessage(subscription);

  let content: React.ReactNode;

  if (allowTrialWithoutPayment) {
    content = (
      <>
        <Typography variant="h4">{trialEndMessage}</Typography>
        <Typography>
          Enjoying Toolkit?&nbsp;
          <Link href="/subscribe" as={ReactRouterLink}>
            Upgrade now
          </Link>
          &nbsp;to continue enjoying market-based adjustments!
        </Typography>
      </>
    );
  } else {
    content = <Typography>{trialEndMessage}</Typography>;
  }

  return <Block>{content}</Block>;
};
